import { render, staticRenderFns } from "./QuizSubmissionViewer.vue?vue&type=template&id=937de812&scoped=true&"
import script from "./QuizSubmissionViewer.vue?vue&type=script&lang=js&"
export * from "./QuizSubmissionViewer.vue?vue&type=script&lang=js&"
import style0 from "./QuizSubmissionViewer.vue?vue&type=style&index=0&id=937de812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937de812",
  null
  
)

export default component.exports